import { render, staticRenderFns } from "./LogisticList.vue?vue&type=template&id=ce8976c8&scoped=true&"
import script from "./LogisticList.vue?vue&type=script&lang=js&"
export * from "./LogisticList.vue?vue&type=script&lang=js&"
import style0 from "./LogisticList.vue?vue&type=style&index=0&id=ce8976c8&scoped=true&lang=css&"
import style1 from "./LogisticList.vue?vue&type=style&index=1&id=ce8976c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8976c8",
  null
  
)

export default component.exports